import { Info } from '@phosphor-icons/react'
import { PopoverPortal } from '@radix-ui/react-popover'
import { BardTable as BardTableType } from '@/src/@types/statamic'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/src/components/core/Popover'

export default function BardTable({ table }: BardTableType) {
  return (
    <div className="grid gap-x-7 md:max-w-xl">
      {table.map((table_entry, index) => (
        <div
          key={index}
          className="flex justify-between rounded-lg p-5 odd:bg-gradient-100 md:p-5"
        >
          <p className="flex-1 text-sm font-bold md:text-lg">
            {table_entry.text_left}
            {table_entry.tooltip && (
              <Popover>
                <PopoverTrigger>
                  <Info weight="fill" />
                </PopoverTrigger>
                <PopoverPortal>
                  <PopoverContent>{table_entry.tooltip}</PopoverContent>
                </PopoverPortal>
              </Popover>
            )}
          </p>
          {table_entry.text_right && (
            <p className="text-right text-sm md:text-lg">
              {table_entry.text_right}
            </p>
          )}
        </div>
      ))}
    </div>
  )
}
